<template>
  <div>
    <div class="schedule"  ref='cardPanned'>
      <div class="schedule-title">
        <div>
          <h2>Tarefas em Aberto</h2>
        </div>
        <div class="menu">
          <v-btn flat icon :disabled="first || itemsProp.length <= qtt" @click="updateData(-1)" color="black" style="margin: 0;">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <strong v-if="itemsLength === 0">0 - 0 de 0</strong>
          <strong v-else>{{((index) * qtt) + 1}} - {{(((index + 1) * qtt) < itemsLength) ? (index + 1) * qtt : itemsLength}} de {{itemsLength}}</strong>
          <v-btn flat icon :disabled="last || itemsProp.length <= qtt" @click="updateData(1)" color="black" style="margin: 0;">
            <v-icon>arrow_forward</v-icon>
          </v-btn>
        </div>
        <v-tooltip top>
          <v-icon slot="activator" color="black" size="20px">{{'info'}}</v-icon>
          <span class="dica">Mostrar todas as tarefas que estão em aberto para o período selecionado</span>
        </v-tooltip>
      </div>
      <div class="center content" v-if="loading">
        <img class="loader" :src="`${basePath}images/loader.gif`" width="100px" />
      </div>
      <div v-else-if="items.length > 0" class="content">
        <div class="item" v-for="item in items" :key="item.id">
          <div class="image">
            <div v-if="item.user">
              <v-tooltip top>
                <img slot="activator" v-if="item.photo" class="mr-2 user-image" :src="`${basePath}uploads/users/${item.photo}`" alt="avatar">
                <div slot="activator" class="usuario" v-else>
                  <h3>{{getFirstLetters(item.user)}}</h3>
                </div>
                <span>{{item.user || 'Sem Responsável'}}</span>
              </v-tooltip>
            </div>
            <div v-else>
              <v-tooltip top>
                <v-avatar slot="activator" size="50px" color="#00acc2" class="avatar">
                  <v-icon size="35px" color="white">person</v-icon>
                </v-avatar>
                <span>{{item.user || 'Sem Responsável'}}</span>
              </v-tooltip>
            </div>
          </div>
          <div class="client" v-if="item.client">
            <v-chip outline small>
              <v-avatar v-if="item.client.auto && item.client.connection_company && item.client.connection_company.logo_path">
                <img :src="`${basePath}uploads/companies/${item.client.connection_company.logo_path}`" alt="a23vatar">
              </v-avatar>
              <v-avatar v-else-if="!item.client.auto && item.client.logo_path">
                <img :src="`${basePath}uploads/connections/${item.client.logo_path}`" alt="a23vatar">
              </v-avatar>
              <v-avatar v-else class="avatar">
                <span class="avatar-letters"> {{ getFirstLetters(item.client.id_text) }} </span>
              </v-avatar>
              <span class="align-left">{{item.client.id_text | formatAbbreviation(20)}}</span>
            </v-chip>
          </div>
          <div style="width: 100%">
          <v-tooltip bottom>
            <router-link v-if="checkPermission('tasks', 'manage')" slot="activator" :to="`/task/${item.id}?return=dashboard_movement`">
              <span :class="'task-description mx-2'+(item.done ? ' done' : (item.outdated ? ' outdated' : ''))" :style="'overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; word-break: break-all;'+(item.client ? 'margin-bottom: 25px;' : '')">{{(item.identifier + ' - ' + item.id_text) }}</span>
            </router-link>
            <span v-else slot="activator" :class="'task-description mx-2'+(item.done ? ' done' : (item.outdated ? ' outdated' : ''))" :style="'overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; word-break: break-all;'+(item.client ? 'margin-bottom: 25px;' : '')">{{(item.identifier + ' - ' + item.id_text) }}</span>
            <span><p-entire-field :field="item.id_text"></p-entire-field></span>
          </v-tooltip>
          </div>
          <!--<v-tooltip bottom>-->
          <v-chip slot="activator" v-if="item.status" disabled style="border: 1px solid #00acc2; flex: 0;" text-color="#00acc2" color="#fff">{{item.status | formatAbbreviation(12)}}</v-chip>
          <v-chip slot="activator" v-else disabled style="max-width: 80px; border: 1px solid #00acc2; flex: 0;" text-color="#00acc2" color="#fff"></v-chip>
          <!--<span>{{item.status.length > 0 ? item.status : 'Não possui status atual' }}</span>-->
          <!--</v-tooltip>-->

        </div>
      </div>
      <div class="content" v-else>
        <span class="no-data">Não possui registros</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .schedule {
    background: #00acc2;
    padding: 2px;
    height: 424px;
  }

  .schedule-title {
    padding-left: 5px;
    color: #fff;
    display: flex;
    justify-content: space-between;
  }

  .menu {
    position: relative;
  }

  .avatar {
    background: linear-gradient(to right, #00F260 , #0575E6);
    color: #fff;
  }

  .avatar-letters {
    font-weight: bold;
    color: #fff;
    font-size: 0.9em;
  }

  .content {
    background: #fff;
    padding: 0 8px;
    display: flex;
    flex-direction: column;
    height: 381px;
  }

  .client {
    position: absolute;
    left: 65px;
    bottom: -3px;
  }

  .no-data {
    background: #fff;
    height: 304px;
    flex-direction: column;
    justify-content: center;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #00acc2;
    padding: 5px 0;
    height: 77px;
    position: relative;
  }

  .item:nth-of-type(5) {
    border-bottom: none;
  }

  .item .usuario {
    color: #fff;
    background-color: #00acc2;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .item .usuario h3 {
    font-size: 1.5em;
  }

  .user-image {
    height: 50px;
    width: 50px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
  }

  .align-left {
    align-items: left;
  }

  .item span.done {
    text-decoration: line-through;
  }

  .item span.outdated {
    color: #dc3545;
  }

  @media screen and (max-width: 800px) {
    .schedule-title {
      align-items: center;
    }

    .schedule-title h2 {
      font-size: 1.15em;
    }
  }

  @media screen and (min-width: 2500px) {
    /* .schedule {
      height: calc(50vh);
    }

    .content {
      height: calc(50vh - 64px);
    } */

    .schedule-title h2 {
      font-size: 2.5em;
    }

    .dica{
      font-size: 2em;
    }

    span.task-description {
      font-size: 1.5em;
    }

    span.no-data {
      font-size: 2em;
    }
  }
</style>

<script>
  import PEntireField from './../../shared/PEntireField'
  import general from '../../../mixin/general'
  import access from '../../../mixin/access'

  export default {
    props: {itemsProp: Array, loading: Boolean},
    components: {PEntireField},
    mixins: [general, access],
    data: () => ({
      timeInterval: 0,
      items: [],
      basePath: process.env.API,
      index: 0,
      first: false,
      last: false,
      qtt: 5,
      itemsLength: 0
    }),
    mounted () {
      this.createData()
      // this.qttTaskInterval = setInterval(() => {
      //   }, 3000)
      this.timeInterval = setInterval(() => {
        if (document.fullscreenElement) {
          if (Math.ceil(this.itemsLength / this.qtt) !== 0) { this.updateData(((this.index + 1) >= Math.ceil(this.itemsLength / this.qtt)) ? -this.index : 1) }
        }
        // se o index possuir uma valor maior que o total de paginas ai o index volta para primeiro posição
        if ((this.index + 1) > (Math.ceil(this.itemsLength / this.qtt))) {
          this.index = 0
          this.createData()
        }
      }, 10000)
    },
    watch: {
      itemsProp () {
        this.createData()
      }
    },
    methods: {
      createData: function (i = this.index) {
        this.items = []
        Object.assign(this.items, this.itemsProp)
        this.index = i
        this.itemsLength = this.items.length
        this.items = this.items.splice(this.index * this.qtt, this.qtt)
        this.last = ((this.index + 1) === (Math.ceil(this.itemsLength / this.qtt)))
        this.first = (this.index === 0)
      },
      updateData (i) {
        Object.assign(this.items, this.itemsProp || [])
        this.index = this.index + i
        this.items = this.items.splice(this.index * this.qtt, this.qtt)
        this.last = ((this.index + 1) === (Math.ceil(this.itemsLength / this.qtt)))
        this.first = (this.index === 0)
      }
    },
    destroyed () {
      clearInterval(this.timeInterval)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/cards/CardPlannedTasks.vue